import styled from 'styled-components'

import Box from '@totallymoney/ui/components/Box'
import theme from '@totallymoney/ui/theme'

import { borderStyle } from '@styles/borderStyles'

import { StyledLoansTableItemProductDetail } from '../LoansTableItemProductDetail/LoansTableItemProductDetail.styled'

const StyledContentBase = styled(Box)`
    ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
        padding-top: ${theme.space10};
        border-top: ${borderStyle};

        ${theme.mediaMediumPlus`
            border-left: ${borderStyle};
            border-top: 0;
            padding-left: ${theme.space20};
            padding-top: 0;
        `}
    }
`

export const StyledLoansTableMarketingOfferContentBase = styled(
    StyledContentBase
)`
    ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
        &:nth-child(4n) {
            ${theme.mediaMediumPlus`
                border-left: 0;
                padding-left: 0;
            `}

            ${theme.mediaLargePlus`
                border-left: ${borderStyle};
                padding-left: ${theme.space20}; 
            `}
        }
    }
`

export const StyledLoanTableContentBase = styled(StyledContentBase)``
